import React from 'react';
import { Search } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

const CreatorHeader: React.FC = () => {
  const { user } = useAuth();

  return (
    <header className="fixed top-0 left-16 right-0 h-16 bg-creator-surface dark:bg-gray-900 shadow-sm z-30 border-b border-creator-border dark:border-gray-700">
      <div className="h-full px-6 flex items-center justify-between">
        {/* Left: Title */}
        <div className="flex items-center space-x-6">
          <h1 className="text-2xl font-serif font-bold text-creator-text dark:text-gray-100">
            Creator Studio
          </h1>
        </div>

        {/* Center: Search Bar */}
        <div className="flex-1 max-w-2xl mx-8">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search POIs, cards, locations..."
              className="w-full h-10 pl-12 pr-4 rounded-full border border-creator-border dark:border-gray-700 bg-creator-bg dark:bg-gray-800 text-creator-text dark:text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-creator-accent focus:border-transparent transition-all"
            />
          </div>
        </div>

        {/* Right: Web Dashboard Tag and Profile */}
        <div className="flex items-center space-x-4">
          <span className="px-3 py-1 text-xs font-medium bg-creator-bg dark:bg-gray-800 text-creator-text dark:text-gray-300 rounded-full border border-creator-border dark:border-gray-700">
            Web Dashboard
          </span>

          {/* User Profile Avatar */}
          <Link
            to="/profile"
            className="w-10 h-10 rounded-full bg-creator-accent flex items-center justify-center text-white font-medium hover:bg-opacity-90 transition-all shadow-sm"
            title={user?.displayName || user?.email || 'Profile'}
          >
            {user?.profileImageUrl ? (
              <img
                src={user.profileImageUrl}
                alt="Profile"
                className="w-full h-full rounded-full object-cover"
              />
            ) : (
              <span className="text-sm uppercase">
                {user?.firstName?.charAt(0) || user?.email?.charAt(0) || 'U'}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default CreatorHeader;
